import styled, { keyframes } from 'styled-components';

export const BASE_HEIGHT = 0.15; // minimum scaleY
export const STOP_ANIMATION_DURATION = 200; // ms

export const CSS_EASINGS = [
  'cubic-bezier(0.25, 0.46, 0.45, 0.94)', // easeOutQuad
  'cubic-bezier(0.215, 0.61, 0.355, 1)', // easeOutCubic
  'cubic-bezier(0.455, 0.03, 0.515, 0.955)', // easeInOutQuad
  'cubic-bezier(0.39, 0.575, 0.565, 1)', // easeOutSine-ish
] as const;

const pump = keyframes`
  0%   { transform: scaleY(var(--base-scale)); }
  100% { transform: scaleY(var(--max-scale)); }
`;

type BarProps = {
  $durationMs: number;
  $delayMs: number;
  $timing: string;
};

export const Bar = styled.div<BarProps>`
  --base-scale: ${BASE_HEIGHT};
  --max-scale: 1;

  width: 4px;
  height: 32px;
  margin: 0 1.5px;
  border-radius: 6px;
  background: currentColor;
  transform-origin: bottom center;
  transform: scaleY(var(--base-scale));
  will-change: transform;

  animation-name: ${pump};
  animation-duration: ${({ $durationMs }) => `${$durationMs}ms`};
  animation-delay: ${({ $delayMs }) => `${$delayMs}ms`};
  animation-iteration-count: infinite;
  animation-direction: alternate;
  animation-timing-function: ${({ $timing }) => $timing};
  animation-fill-mode: both;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    transition: none;
  }
`;

export const VisualiserContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 52px;
  padding: 0 8px;
`;
